import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
	/** Tip loading indikatora */
	variant?: 'fullscreen' | 'inline' | 'card';
	/** Poruka koja se prikazuje */
	message?: string;
	/** Veličina spinnera */
	size?: 'small' | 'medium' | 'large';
	/** Dodatne CSS klase */
	className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ variant = 'inline', message = 'Učitava...', size = 'medium', className = '' }) => {
	const getVariantClass = () => {
		switch (variant) {
			case 'fullscreen':
				return 'loading-fullscreen';
			case 'card':
				return 'loading-card';
			default:
				return 'loading-inline';
		}
	};

	const getSizeClass = () => {
		switch (size) {
			case 'small':
				return 'loading-small';
			case 'large':
				return 'loading-large';
			default:
				return 'loading-medium';
		}
	};

	if (variant === 'fullscreen') {
		return (
			<div className={`loading-container ${getVariantClass()} ${className}`}>
				<div className={`loading-spinner ${getSizeClass()}`}>
					<div className='loading-icon'>
						<div className='spinner'></div>
					</div>
					<p className='loading-message'>{message}</p>
				</div>
			</div>
		);
	}

	if (variant === 'card') {
		return (
			<div className={`loading-card-container ${getSizeClass()} ${className}`}>
				<div className='loading-icon'>
					<div className='spinner'></div>
				</div>
				<p className='loading-message'>{message}</p>
			</div>
		);
	}

	// Inline variant
	return (
		<div className={`loading-inline-container ${getSizeClass()} ${className}`}>
			<div className='loading-icon'>
				<div className='spinner'></div>
			</div>
			<span className='loading-message'>{message}</span>
		</div>
	);
};

export default LoadingSpinner;
